import { Button } from "@hireart/component-library";
import plusIcon from "hireart-icons/plus.svg";
import PropTypes from "prop-types";
import { BreakShape } from "common/utils/timesheet";
import { ShiftBreaks } from "./sub-components/ShiftBreaks";

export const BreakManager = ({
  breaks,
  isReadOnly,
  hoursBreakEmployee = null,
  shiftDate,
  onBreakChange,
  onRemoveBreak,
  onAddBreak,
}) => {
  return (
    <>
      {/* Breaks Section */}
      <ShiftBreaks
        breaks={breaks}
        isReadOnly={isReadOnly}
        hoursBreakEmployee={hoursBreakEmployee}
        shiftDate={shiftDate}
        onBreakChange={onBreakChange}
        onRemoveBreak={onRemoveBreak}
      />
      {!isReadOnly && (
        <Button
          onClick={onAddBreak}
          color="secondary"
          size="sm"
          iconStart={plusIcon}
          className="mt-2 flex-shrink-0 self-start"
        >
          Add break
        </Button>
      )}
    </>
  );
};

BreakManager.propTypes = {
  breaks: PropTypes.arrayOf(BreakShape).isRequired,
  isReadOnly: PropTypes.bool.isRequired,
  hoursBreakEmployee: PropTypes.number,
  shiftDate: PropTypes.instanceOf(Date),
  onBreakChange: PropTypes.func.isRequired,
  onRemoveBreak: PropTypes.func.isRequired,
  onAddBreak: PropTypes.func.isRequired,
};
